// extracted by mini-css-extract-plugin
export default {"stickyHeader":"YSmxjy8M","_isSticked":"DsUeL9yX","_withShadow":"CXPIStGu","_toHide":"OTZ3wSwA","_toShow":"Rlyb_mpC"};